// extracted by mini-css-extract-plugin
module.exports = {"quantityControls":"style_quantityControls__3j5jX","quantityInput":"style_quantityInput__2AQJr"};